export default "__VITE_PUBLIC_ASSET__cd313600__"